import React from 'react';
import {
  Person as PersonIcon,
  Business as BusinessIcon,
  Science as ScienceIcon,
  Handshake as HandshakeIcon,
} from '@mui/icons-material';
import { createFilterOptions } from '@mui/material';
import { EntityType } from '../../types/workflow';
import type { EntityOption } from './EntityOptionItem';

/**
 * Get the chip color for an entity type.
 */
export const getEntityChipColor = (
  entityType: EntityType
): 'primary' | 'secondary' | 'info' | 'success' => {
  switch (entityType) {
    case 'Farmer':
      return 'primary';
    case 'Agent':
      return 'secondary';
    case 'Lab':
      return 'info';
    case 'Partner':
      return 'success';
    default:
      return 'primary';
  }
};

/**
 * Get the chip variant for an entity type.
 * Lab uses outlined to distinguish it visually from Farmer/Agent.
 */
export const getEntityChipVariant = (
  entityType: EntityType
): 'filled' | 'outlined' => {
  return entityType === 'Lab' ? 'outlined' : 'filled';
};

/**
 * Get the icon component for an entity type.
 */
export const getEntityIcon = (entityType: EntityType): React.ReactNode => {
  switch (entityType) {
    case 'Farmer':
      return React.createElement(PersonIcon, { fontSize: 'small' });
    case 'Agent':
      return React.createElement(BusinessIcon, { fontSize: 'small' });
    case 'Lab':
      return React.createElement(ScienceIcon, { fontSize: 'small' });
    case 'Partner':
      return React.createElement(HandshakeIcon, { fontSize: 'small' });
    default:
      return React.createElement(PersonIcon, { fontSize: 'small' });
  }
};

/**
 * Client-side filter that matches across entityName, email, and secondaryText.
 */
export const entityFilterOptions = createFilterOptions<EntityOption>({
  stringify: (option) =>
    `${option.entityName} ${option.email ?? ''} ${option.secondaryText ?? ''}`,
});
